import { createRoot } from 'react-dom/client';

import './App.css';
import App from './App';

createRoot(document.getElementById('root')!).render(<App />);
